var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 440,
    viewBox: "0 0 357 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_284_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.097 212.291L238.912 212.291L205.501 248.089L172.097 212.291Z",
    fill: "url(#paint0_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.095 212.287L238.909 212.287L205.501 98.0034L172.095 212.287Z",
    fill: "url(#paint1_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.59 277.848L205.508 248.064L172.097 212.287L141.59 277.848Z",
    fill: "url(#paint2_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.414 277.852L205.504 248.066L141.594 277.852L142.296 312.358L205.504 333.995L268.711 312.358L269.414 277.852Z",
    fill: "url(#paint3_linear_284_14)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.911 291.029L282 253.614L238.911 212.287L172.097 212.287L129.008 253.614L172.097 291.029L238.911 291.029Z",
    fill: "url(#paint4_radial_284_14)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.097 291.029L238.912 291.029L205.501 334L172.097 291.029Z",
    fill: "url(#paint5_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.097 291.029L238.912 291.029L205.501 98.0034L172.097 291.029Z",
    fill: "url(#paint6_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.715 312.355L238.912 291.029L205.501 334L268.715 312.355Z",
    fill: "url(#paint7_linear_284_14)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.291 312.355L172.094 291.029L205.505 334L142.291 312.355Z",
    fill: "url(#paint8_linear_284_14)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.714 312.355L238.911 291.028L282 253.613L268.714 312.355Z",
    fill: "url(#paint9_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.294 312.355L172.097 291.028L129.008 253.613L142.294 312.355Z",
    fill: "url(#paint10_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5 98L238.911 291.029L282 253.614L205.5 98Z",
    fill: "url(#paint11_linear_284_14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.5 98L172.089 291.029L129 253.614L205.5 98Z",
    fill: "url(#paint12_linear_284_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_284_14",
    x: 0,
    y: 0,
    width: 357,
    height: 440,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -27,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 51
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.32549 0 0 0 0 0.919059 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_284_14"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.966667 0 0 0 0 0.539722 0 0 0 0 0.821506 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_284_14",
    result: "effect2_dropShadow_284_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_284_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_14",
    x1: 238.912,
    y1: 293.551,
    x2: 156.816,
    y2: 303.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227296,
    stopColor: "#47FFDE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_14",
    x1: 238.911,
    y1: 293.55,
    x2: 156.815,
    y2: 303.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227296,
    stopColor: "#47FFDE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_14",
    x1: 129.008,
    y1: 257.06,
    x2: 182.513,
    y2: 260.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227296,
    stopColor: "#47FFDE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_284_14",
    x1: 205.504,
    y1: 227.412,
    x2: 205.504,
    y2: 354.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FFDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_284_14",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.504 251.658) rotate(-180) scale(113.271 58.2988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_284_14",
    x1: 238.912,
    y1: 293.55,
    x2: 156.816,
    y2: 303.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227296,
    stopColor: "#47FFDE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_284_14",
    x1: 205.504,
    y1: 303.634,
    x2: 205.504,
    y2: 122.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799517,
    stopColor: "#47FFDE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_284_14",
    x1: 237.108,
    y1: 291.029,
    x2: 209.846,
    y2: 340.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BFFE7",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322994",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_284_14",
    x1: 173.898,
    y1: 291.029,
    x2: 151.389,
    y2: 322.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BFFE7",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322994",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_284_14",
    x1: 282,
    y1: 257.06,
    x2: 228.391,
    y2: 308.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586705,
    stopColor: "#47FFDE",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_284_14",
    x1: 129.008,
    y1: 257.06,
    x2: 166.045,
    y2: 303.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B0CCC",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FFDE",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_284_14",
    x1: 269.406,
    y1: 267.243,
    x2: 245.873,
    y2: 96.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665873,
    stopColor: "#5DFFE2",
    stopOpacity: 0.823651
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477BFF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_284_14",
    x1: 176.947,
    y1: 291.029,
    x2: 166.569,
    y2: 117.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227296,
    stopColor: "#47FFDE",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D61FF",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about_us.1c97b33c4e65bf2ee12a1f52dcecda94.svg";
export { ForwardRef as ReactComponent };